/* tslint:disable */
/* eslint-disable */
/**
 * EVE Swagger Interface
 * An OpenAPI for EVE Online
 *
 * The version of the OpenAPI document: 1.30
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * position object
 * @export
 * @interface GetUniverseStationsStationIdPosition
 */
export interface GetUniverseStationsStationIdPosition {
    /**
     * x number
     * @type {number}
     * @memberof GetUniverseStationsStationIdPosition
     */
    x: number;
    /**
     * y number
     * @type {number}
     * @memberof GetUniverseStationsStationIdPosition
     */
    y: number;
    /**
     * z number
     * @type {number}
     * @memberof GetUniverseStationsStationIdPosition
     */
    z: number;
}

/**
 * Check if a given object implements the GetUniverseStationsStationIdPosition interface.
 */
export function instanceOfGetUniverseStationsStationIdPosition(value: object): value is GetUniverseStationsStationIdPosition {
    if (!('x' in value) || value['x'] === undefined) return false;
    if (!('y' in value) || value['y'] === undefined) return false;
    if (!('z' in value) || value['z'] === undefined) return false;
    return true;
}

export function GetUniverseStationsStationIdPositionFromJSON(json: any): GetUniverseStationsStationIdPosition {
    return GetUniverseStationsStationIdPositionFromJSONTyped(json, false);
}

export function GetUniverseStationsStationIdPositionFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetUniverseStationsStationIdPosition {
    if (json == null) {
        return json;
    }
    return {
        
        'x': json['x'],
        'y': json['y'],
        'z': json['z'],
    };
}

export function GetUniverseStationsStationIdPositionToJSON(json: any): GetUniverseStationsStationIdPosition {
    return GetUniverseStationsStationIdPositionToJSONTyped(json, false);
}

export function GetUniverseStationsStationIdPositionToJSONTyped(value?: GetUniverseStationsStationIdPosition | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'x': value['x'],
        'y': value['y'],
        'z': value['z'],
    };
}

